import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class NotificationItemInfo extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-notification__info',
            className,
        ];
    }

}

NotificationItemInfo.propTypes = propTypes;

NotificationItemInfo.defaultProps = defaultProps;

export default NotificationItemInfo;
